declare const jasmine: any;

export const stubWindow = {
  nativeWindow: {
    location: {
      origin: 'origin',
      href: '/',
      assign: () => jasmine.createSpy('assign'),
    },
    open: () => jasmine.createSpy('open'),
  },
};
